import React, {useEffect, useRef, useState} from 'react';
import CustomButton from '../../../components/mazraeKit/customButton';

import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../store/redux';
import {useDebounceEffect} from '../../../utilities/hooks/imageCropper/useDebounceEffect';
import ReactCrop, {
  Crop,
  PixelCrop,
  centerCrop,
  makeAspectCrop,
} from 'react-image-crop';
import {canvasPreview} from '../../../utilities/hooks/imageCropper/canvasPreview';
import './style.css';
import {toast} from 'react-toastify';
import {useNavigate} from 'react-router-dom';
import {addingCropedImage, clearImage} from '../../../store/redux/editProfile';

const AddPicture = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {imageFile} = useSelector((state: RootState) => state.editImageProfile);
  const [imgSrc, setImgSrc] = useState('');
  const previewCanvasRef = useRef<HTMLCanvasElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  const [crop, setCrop] = useState<Crop>();
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();

  function onSelectFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      setCrop(undefined);
      const reader = new FileReader();
      reader.addEventListener('load', () =>
        setImgSrc(reader.result?.toString() || ''),
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  }
  useEffect(() => {
    imageFile && onSelectFile(imageFile);
  }, [imageFile]);

  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(imgRef.current, previewCanvasRef.current, completedCrop);
      }
    },
    100,
    [completedCrop],
  );
  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    const {width, height} = e.currentTarget;
    setCrop(centerAspectCrop(width, height, 1));
  }

  async function onDownloadCropClick() {
    setIsLoading(true);

    if (!previewCanvasRef.current) {
      throw new Error('Crop canvas does not exist');
    }

    previewCanvasRef?.current.toBlob(blob => {
      if (!blob) {
        toast.error('مشکلی در آپلود عکس پیش آمده.');
      } else {
        if (
          imageFile &&
          imageFile?.target.files &&
          imageFile?.target.files.length > 0
        ) {
          const file = new File([blob], imageFile?.target.files[0].name, {
            type: imageFile.type,
          });

          dispatch(addingCropedImage(file));
          dispatch(clearImage());
          navigate(-1);
        }
      }
      setIsLoading(false);
    });
  }

  return (
    <div className="d-flex w-full h-full flex-col justify-between">
      <div className="w-full ReactCrop__child-wrapper-image-cropper flex">
        {!!imgSrc && (
          <ReactCrop
            className="h-full w-full"
            crop={crop}
            onChange={(_, percentCrop) => setCrop(percentCrop)}
            onComplete={c => setCompletedCrop(c)}
            aspect={1}
          >
            <img
              className="h-full object-contain"
              ref={imgRef}
              alt="Crop me"
              src={imgSrc}
              onLoad={onImageLoad}
            />
          </ReactCrop>
        )}
        {!!completedCrop && (
          <>
            <div className=" d-none">
              <canvas
                ref={previewCanvasRef}
                style={{
                  border: '1px solid black',
                  objectFit: 'contain',
                  width: completedCrop.width,
                  height: completedCrop.height,
                }}
              />
            </div>
          </>
        )}
      </div>
      <div className="d-flex gap-2 px-2  w-full items-center rounded-t-[8px] text-md font-Medium h-[64px] shadow-dropShadow">
        <CustomButton
          disabled={isLoading}
          onClick={() => {
            onDownloadCropClick();
          }}
          type="button"
          title=" انتخاب تصویر"
          isLoading={isLoading}
          className="bg-farm-shop-500 w-[50%] text-white h-[48px] flex rounded-[8px] items-center justify-center border border-farm-shop-500"
        />
        <CustomButton
          onClick={() => {
            navigate(-1);
            dispatch(clearImage());
          }}
          type="submit"
          title="انصراف"
          isLoading={false}
          className="text-farm-shop-500 w-[50%] h-[48px] flex items-center justify-center rounded-[8px] border border-farm-shop-500"
        />
      </div>
    </div>
  );
};

export default AddPicture;
function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  );
}
